import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Lock } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';
import { useLanguage } from '@/context/LanguageContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function Login() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { t } = useLanguage();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(`${BACKEND_URL}/api/auth/login`, { username, password });
      localStorage.setItem('token', response.data.access_token);
      navigate('/dashboard');
    } catch (error) {
      toast.error(t('login', 'error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-gray-50">
      <Navbar />
      <div className="pt-32 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md mx-auto">
          <div className="bg-white rounded-3xl border-2 border-gray-200 p-8 shadow-xl" data-testid="login-form-container">
            <div className="text-center mb-8">
              <div className="w-16 h-16 bg-gradient-to-br from-[#0066b2] to-[#005494] rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Lock className="w-8 h-8 text-white" />
              </div>
              <h1 className="text-3xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk' }}>{t('login', 'title')}</h1>
              <p className="text-gray-600 mt-2">{t('login', 'subtitle')}</p>
            </div>
            <form onSubmit={handleLogin} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">{t('login', 'username')}</label>
                <Input value={username} onChange={(e) => setUsername(e.target.value)} placeholder="admin" data-testid="login-username" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">{t('login', 'password')}</label>
                <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="********" data-testid="login-password" />
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-[#0066b2] hover:bg-[#005494]" data-testid="login-submit">
                {loading ? t('login', 'logging') : t('login', 'loginBtn')}
              </Button>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
